const assetBase = '/10-4-admin/dist/da';
export const environment = {
    assetBase: assetBase,
    production: true,
    apiBase: '',
    locale: 'da',
};
